import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-station-line-tick.svg'
import _imports_1 from '@/assets/icon-rectangle-w.svg'
import _imports_2 from '@/assets/area/icon-l-w.svg'
import _imports_3 from '@/assets/area/icon-l-active.svg'
import _imports_4 from '@/assets/icon-d-heatmap.svg'
import _imports_5 from '@/assets/icon-d-heatmap-active.svg'
import _imports_6 from '@/assets/icon-r-compare.svg'
import _imports_7 from '@/assets/icon-r-compare-active.svg'
import _imports_8 from '@/assets/icon-r-heatmap.svg'
import _imports_9 from '@/assets/icon-r-heatmap-active.svg'
import _imports_10 from '@/assets/icon-station-user-w.svg'
import _imports_11 from '@/assets/icon-station-user-active.svg'
import _imports_12 from '@/assets/btn_close-w.svg'


const _withScopeId = n => (_pushScopeId("data-v-9ea72b48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "jr-w-full jr-cursor-pointer jr-relative"
}
const _hoisted_2 = { class: "jr-p-6 jr-flex jr-items-center jr-text-white" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-mr-5",
  src: _imports_0,
  alt: "station line"
}, null, -1))
const _hoisted_4 = { class: "jr-text-sm-1 jr-font-medium jr-inline-block jr-align-middle" }
const _hoisted_5 = {
  key: 1,
  class: "jr-w-full jr-cursor-pointer jr-relative"
}
const _hoisted_6 = { class: "jr-p-6 jr-flex jr-items-center jr-text-white" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-mr-5",
  src: _imports_1,
  alt: "rectangle"
}, null, -1))
const _hoisted_8 = { class: "jr-text-sm-1 jr-font-medium jr-inline-block jr-align-middle" }
const _hoisted_9 = {
  key: 2,
  class: "jr-w-full jr-cursor-pointer jr-relative"
}
const _hoisted_10 = {
  class: "jr-pr-4",
  src: _imports_2,
  alt: "l"
}
const _hoisted_11 = {
  src: _imports_3,
  class: "jr-pr-6",
  alt: "icon l active"
}
const _hoisted_12 = {
  key: 0,
  class: "jr-mr-3",
  src: _imports_4,
  alt: "heatmap"
}
const _hoisted_13 = {
  key: 1,
  class: "jr-mr-3",
  src: _imports_5,
  alt: "heatmap"
}
const _hoisted_14 = { class: "jr-text-xs jr-font-medium jr-inline-block jr-align-middle jr-whitespace-nowrap" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("駅利用者の居住地・")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("勤務地分布ヒートマップ")
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 3,
  class: "jr-w-full jr-cursor-pointer jr-relative"
}
const _hoisted_20 = {
  class: "jr-pr-4",
  src: _imports_2,
  alt: "l"
}
const _hoisted_21 = {
  src: _imports_3,
  class: "jr-pr-6",
  alt: "icon l active"
}
const _hoisted_22 = {
  key: 0,
  class: "jr-mr-3",
  src: _imports_6,
  alt: "compare"
}
const _hoisted_23 = {
  key: 1,
  class: "jr-mr-3",
  src: _imports_7,
  alt: "compare"
}
const _hoisted_24 = { class: "jr-text-xs jr-font-medium jr-inline-block jr-align-middle jr-whitespace-nowrap" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("駅周辺移動元・先")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("エリア分布")
const _hoisted_28 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  class: "jr-pr-4",
  src: _imports_2,
  alt: "l"
}
const _hoisted_30 = {
  src: _imports_3,
  class: "jr-pr-6",
  alt: "icon l active"
}
const _hoisted_31 = {
  key: 0,
  class: "jr-mr-3",
  src: _imports_8,
  alt: "heatmap"
}
const _hoisted_32 = {
  key: 1,
  class: "jr-mr-3",
  src: _imports_9,
  alt: "heatmap"
}
const _hoisted_33 = { class: "jr-text-xs jr-font-medium jr-inline-block jr-align-middle jr-whitespace-nowrap" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("時間帯別・駅周辺人数")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode("時間帯別・駅周辺人流")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode("マップ")
const _hoisted_39 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  class: "jr-mr-2.5",
  src: _imports_10,
  alt: "station user"
}
const _hoisted_41 = {
  class: "jr-mr-2.5",
  src: _imports_11,
  alt: "station user"
}
const _hoisted_42 = { class: "close" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: "btn close"
}, null, -1))
const _hoisted_44 = [
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    "data-html2canvas-ignore": "true",
    class: _normalizeClass(["jr-fixed jr-z-10 jr-top-0 jr-left-0 jr-h-screen jr-bg-primary jr-shadow-lg", {'right_column': !_ctx.isCapturing, 'jr-opacity-0': _ctx.isCapturing}]),
    style: _normalizeStyle({ width: _ctx.sbMinimum ? '64px' : '240px' })
  }, [
    _createElementVNode("ul", null, [
      (_ctx.isHeatmap)
        ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
            _createVNode(_component_router_link, { to: "/railway_station" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _withDirectives(_createElementVNode("h1", _hoisted_4, "駅選択", 512), [
                    [_vShow, !_ctx.sbMinimum]
                  ])
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isComparison || _ctx.isAnimation)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/railway_polygon" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _withDirectives(_createElementVNode("h1", _hoisted_8, "駅周辺エリア指定", 512), [
                    [_vShow, !_ctx.sbMinimum]
                  ])
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isHeatmap)
        ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
            _createVNode(_component_router_link, { to: "/railway_report/heatmap" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["jr-p-6 jr-flex jr-items-center", { 'jr-bg-primary-light jr-text-primary': _ctx.isHeatmap, 'jr-text-white': !_ctx.isHeatmap }])
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
                    [_vShow, !_ctx.sbMinimum && !_ctx.isHeatmap]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
                    [_vShow, !_ctx.sbMinimum && _ctx.isHeatmap]
                  ]),
                  (!_ctx.isHeatmap)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                    : _createCommentVNode("", true),
                  (_ctx.isHeatmap)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("h1", _hoisted_14, _hoisted_18, 512), [
                    [_vShow, !_ctx.sbMinimum]
                  ])
                ], 2)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isComparison || _ctx.isAnimation)
        ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
            _createVNode(_component_router_link, { to: "/railway_report/comparison" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["jr-p-6 jr-flex jr-items-center", { 'jr-bg-primary-light jr-text-primary': _ctx.isComparison, 'jr-text-white': !_ctx.isComparison }])
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_20, null, 512), [
                    [_vShow, !_ctx.sbMinimum && !_ctx.isComparison]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [
                    [_vShow, !_ctx.sbMinimum && _ctx.isComparison]
                  ]),
                  (!_ctx.isComparison)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                    : _createCommentVNode("", true),
                  (_ctx.isComparison)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("h1", _hoisted_24, _hoisted_28, 512), [
                    [_vShow, !_ctx.sbMinimum]
                  ])
                ], 2)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isComparison || _ctx.isAnimation)
        ? (_openBlock(), _createElementBlock("li", {
            key: 4,
            class: _normalizeClass(["jr-w-full jr-cursor-pointer jr-relative", { 'jr-pointer-events-none': _ctx.isLoadingComparison }])
          }, [
            _createVNode(_component_router_link, { to: "/railway_report/animation" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["jr-p-6 jr-flex jr-items-center", {
                 'jr-bg-primary-light jr-text-primary': _ctx.isAnimation,
                 'jr-text-white': !_ctx.isAnimation,
                 'jr-opacity-50': _ctx.isLoadingComparison
               }])
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_29, null, 512), [
                    [_vShow, !_ctx.sbMinimum && !_ctx.isAnimation]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_30, null, 512), [
                    [_vShow, !_ctx.sbMinimum && _ctx.isAnimation]
                  ]),
                  (!_ctx.isAnimation)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                    : _createCommentVNode("", true),
                  (_ctx.isAnimation)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_32))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("h1", _hoisted_33, _hoisted_39, 512), [
                    [_vShow, !_ctx.sbMinimum]
                  ])
                ], 2)
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("button", {
      class: _normalizeClass(["transition jr-flex jr-items-center jr-justify-center jr-py-3 jr-border jr-border-white jr-rounded-lg jr-m-5", { 'jr-bg-white': _ctx.isHoverReselect }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleNavReselect && _ctx.handleNavReselect(...args))),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hoverReselect(false))),
      onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hoverReselect(true)))
    }, [
      _withDirectives(_createElementVNode("img", _hoisted_40, null, 512), [
        [_vShow, !_ctx.isHoverReselect]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_41, null, 512), [
        [_vShow, _ctx.isHoverReselect]
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["jr-text-sm jr-font-bold", { 'jr-text-primary': _ctx.isHoverReselect, 'jr-text-white': !_ctx.isHoverReselect }])
      }, "駅利用人流はこちら", 2)
    ], 34), [
      [_vShow, !_ctx.sbMinimum && _ctx.isHeatmap]
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", {
        class: "btn_close",
        style: _normalizeStyle({ transform: (_ctx.sbMinimum ? 'rotate(180deg)' : 'rotate(0deg)') })
      }, [
        _createElementVNode("a", {
          href: "javascript:void(0)",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickClose && _ctx.onClickClose(...args)))
        }, _hoisted_44)
      ], 4)
    ])
  ], 6))
}